import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';

function BataSettingsIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
    const [name, setName] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);


    const fetchtableData = async () => {
        setLoading(true);
        fetchData('BataSettingApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Department:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    //handle search

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const SearchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleDelete = async () => {
        deleteData('BataSettingApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('BataSettingApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    // Preprocess data into grouped structure
    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.DepartmentName]) acc[item.DepartmentName] = {};
        if (!acc[item.DepartmentName][item.DesignationName]) acc[item.DepartmentName][item.DesignationName] = [];
        acc[item.DepartmentName][item.DesignationName].push(item);
        return acc;
    }, {});

    let globalSerial = 1;

    const formatTimeSpan = (timeSpan) => {
        if (!timeSpan) return "-";

        const [hoursStr, minutesStr] = timeSpan.split(":");
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);

        if (isNaN(hours) || isNaN(minutes)) return "-";

        const period = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;

        // If minutes are 00, show just the hour (e.g. "9 AM")
        return minutes === 0 ? `${hour12} ${period}` : `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">

            <div style={{ marginTop: '-20px' }}>
                {/* Header Section */}
                <div className="flex flex-wrap justify-between items-center">
                    <h6 className="text-[#134B70] text-lg uppercase tracking-wide font-serif" style={{ fontSize: '14px' }}>
                        Bata Setting
                    </h6>
                    <Tooltip title="Create Bata Setting" arrow>
                        <Button
                            component={Link}
                            to="/BataSettingsCreate"
                            variant="contained"
                            sx={{
                                backgroundColor: "#134B70",
                                textTransform: "none",
                                borderRadius: "20px",
                                fontSize: "12px",
                                padding: "4px 18px",
                                "&:hover": { backgroundColor: "#0d3b66" },
                            }}
                        >
                            + Create
                        </Button>
                    </Tooltip>
                </div>

                {/* Responsive Table Section */}

                <div className="rounded-lg shadow-md border border-gray-300 mt-4">
                    <TableContainer
                        component={Paper}
                        sx={{
                            maxHeight: 550,
                            overflow: "auto",
                            boxShadow: "0px 4px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {["Sl.No", "Shift", "Bata Amount", "Punch-In", "Punch-Out"].map((col, idx) => (
                                        <TableCell
                                            key={idx}
                                            sx={{
                                                background: "linear-gradient(to right, #0D1B2A, #1B2A41)",
                                                color: "white",
                                                fontWeight: 700,
                                                fontSize: 11,
                                                textTransform: "uppercase",
                                                padding: "2px 4px",
                                                borderBottom: "2px solid #0D1B2A",
                                            }}
                                        >
                                            {col}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Object.entries(groupedData).map(([department, designations]) => (
                                    <React.Fragment key={department}>
                                        {/* Department Row */}
                                        <TableRow
                                            sx={{
                                                backgroundColor: "#D6E4F0",
                                                borderBottom: "1px solid #B0C4DE",
                                            }}
                                        >
                                            <TableCell
                                                colSpan={5}
                                                sx={{
                                                    fontWeight: 700,
                                                    fontSize: 13,
                                                    color: "#0D1B2A",
                                                    padding: "6px 12px",
                                                    height: 35,
                                                }}
                                            >
                                                {department}
                                            </TableCell>
                                        </TableRow>

                                        {Object.entries(designations).map(([designation, items]) => (
                                            <React.Fragment key={designation}>
                                                {/* Designation Row */}
                                                <TableRow
                                                    sx={{
                                                        backgroundColor: "#F0F4F8",
                                                        borderBottom: "1px solid #E0E0E0",
                                                    }}
                                                >
                                                    <TableCell
                                                        colSpan={5}
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: 11, // smaller font
                                                            paddingLeft: 16, // reduce left padding
                                                            paddingTop: 1, // reduce top padding
                                                            paddingBottom: 1, // reduce bottom padding
                                                            color: "#1B2A41",
                                                        }}
                                                    >
                                                        {designation}
                                                    </TableCell>
                                                </TableRow>

                                                {/* Data Rows */}
                                                {items.map((item) => (
                                                    <TableRow
                                                        key={item.Id}
                                                        sx={{
                                                            "&:hover": {
                                                                backgroundColor: "#E8F0FE",
                                                                cursor: "pointer",
                                                            },
                                                            transition: "background-color 0.3s",
                                                        }}
                                                    >
                                                        <TableCell sx={{ fontSize: 12, padding: "6px 8px" }}>
                                                            {globalSerial++}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 12, padding: "6px 8px" }}>
                                                            {item.WorkShiftName}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 12, padding: "6px 8px" }}>
                                                            {item.BataAmount}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 12, padding: "6px 8px" }}>                                                            
                                                            {formatTimeSpan(item.PunchInTime)}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 12, padding: "6px 8px" }}>                                                            
                                                            {formatTimeSpan(item.PunchOutTime)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>


                {/* Footer */}
                <div className="text-center text-gray-500 text-xs mt-3">
                    <CopyrightIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }} />
                    <b style={{ fontFamily: "Georgia, serif" }}>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div>

        </div>

    );
}

export default BataSettingsIndex;
